import * as React from "react";
const OneDoorXXLSize = ({ isActive = false }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={83}
    height={71}
    viewBox="0 0 83 71"
    fill={isActive ? "#292747" : "#9493A3"}
    className="gg-scale-[70%] gg-transition gg-duration-150 gg-ease-in-out sm:gg-scale-75 lg:gg-scale-[70%] xl:gg-scale-75 2xl:gg-scale-90"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.5 0v55.43h82V0h-5.06v19H5.56V0zm76.94 21H5.56v29.37h71.88z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.65 67.354a.5.5 0 0 1 0-.708l3.182-3.182a.5.5 0 0 1 .707.707L2.211 66.5h78.505l-2.328-2.329a.5.5 0 0 1 .707-.707l3.182 3.182a.5.5 0 0 1 0 .707l-3.182 3.183a.5.5 0 1 1-.707-.708l2.328-2.328H2.211l2.328 2.328a.5.5 0 1 1-.707.707z"
      fill="#7F7D91"
    />
  </svg>
);
export default OneDoorXXLSize;
